/* eslint-disable */
import { Grid, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import NotificationsIcon from '@material-ui/icons/Notifications';
import classNames from 'classnames';
import moment from 'moment';
import React from 'react';
import { compose } from 'recompose';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import NotificationPropTypes from './Notification.component.props';
import notificationsListStyles from './Notification.component.styles';
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer';

/**
 * Notification
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const Notification = ({ classes, notification: { message, date, isRead } }) => (
  <Grid alignItems="flex-start" className={classNames(classes.flexWrapNowrap, classes.notification, !isRead && classes.unread)} container>
    <Grid item>
      <NotificationsIcon className={classes.icon} />
    </Grid>
    <Grid className={classes.flexGrow1} item>
      <Grid alignItems="center" container>
        <Grid item xs={12}>
          <Typography className={classes.message} color="textPrimary" variant="body2" data-mf-replace-inner={MFSDR}>
            {message}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.activityDescription} color="textSecondary" variant="caption">
            {moment(date).format(`DD MMM YYYY h:mma`)}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  </Grid>
);

Notification.propTypes = NotificationPropTypes;

export default compose(withStyles(themeCreateInjectableStyles(notificationsListStyles), { withTheme: true }))(Notification);
